<app-navbar></app-navbar>

<div class="min-h-screen bg-section pt-24 pb-20 px-4 sm:px-6 lg:px-8 font-serif text-body-text selection:bg-btn/30 relative overflow-hidden">
  
  <!-- Botanical Decoration (Top Left) -->
  <div class="absolute -top-6 -left-6 sm:-top-12 sm:-left-12 w-32 h-32 sm:w-64 sm:h-64 md:w-96 md:h-96 opacity-40 sm:opacity-60 pointer-events-none z-0">
    <img src="amla-top-left.jpg" alt="Amla Branch" class="w-full h-full object-contain mix-blend-multiply aspect-square transform -rotate-12">
  </div>

  <!-- Botanical Decoration (Bottom Right) -->
  <div class="absolute -bottom-6 -right-6 sm:-bottom-12 sm:-right-12 w-40 h-40 sm:w-80 sm:h-80 md:w-[30rem] md:h-[30rem] opacity-40 sm:opacity-60 pointer-events-none z-0">
     <img src="amla-bottom-right.png" alt="Ashwagandha Root" class="w-full h-full object-contain mix-blend-multiply aspect-square transform rotate-12">
  </div>

  <div class="max-w-7xl mx-auto relative z-10">
    
    <div class="flex flex-col md:flex-row gap-8 lg:gap-12">
      <!-- Sidebar / Tab Bar -->
      <aside class="w-full md:w-64 lg:w-72 flex-shrink-0">
        <div class="bg-white border border-[#E5E0D5] rounded-sm p-4 md:p-6 sticky top-20 md:top-24 z-20">
          <!-- User Brief (Desktop only) -->
          <div class="hidden md:block text-center mb-8 pb-8 border-b border-[#E5DDD5]">
            <div class="w-20 h-20 mx-auto bg-heading text-white rounded-full flex items-center justify-center text-2xl font-serif mb-4 shadow-sm">
              {{ getInitials(user?.displayName || 'User') }}
            </div>
            <h3 class="text-lg font-serif text-heading truncate">{{ user?.displayName || 'User' }}</h3>
            <p class="text-xs text-muted truncate mt-1">{{ user?.email }}</p>
          </div>

          <!-- Navigation (Scrollable on mobile) -->
          <nav class="flex md:flex-col gap-1 overflow-x-auto md:overflow-x-visible custom-scrollbar pb-2 md:pb-0">
            <button 
              (click)="setActiveTab('profile')"
              [class.bg-card]="activeTab === 'profile'"
              [class.border-l-btn]="activeTab === 'profile'"
              [class.border-b-btn]="activeTab === 'profile' && !isDesktop"
              [class.md:border-b-transparent]="!isDesktop"
              class="flex-shrink-0 md:w-full text-left px-4 py-3 flex items-center gap-3 border-l-4 md:border-l-4 border-b-2 md:border-b-0 border-l-transparent border-b-transparent hover:bg-card transition-all duration-300 text-[10px] sm:text-xs md:text-sm uppercase tracking-widest text-heading"
            >
              <span class="whitespace-nowrap">My Profile</span>
            </button>
            <button 
              (click)="setActiveTab('orders')"
              [class.bg-card]="activeTab === 'orders'"
              [class.border-l-btn]="activeTab === 'orders'"
              [class.border-b-btn]="activeTab === 'orders' && !isDesktop"
              class="flex-shrink-0 md:w-full text-left px-4 py-3 flex items-center gap-3 border-l-4 md:border-l-4 border-b-2 md:border-b-0 border-l-transparent border-b-transparent hover:bg-card transition-all duration-300 text-[10px] sm:text-xs md:text-sm uppercase tracking-widest text-heading"
            >
              <span class="whitespace-nowrap">My Orders</span>
            </button>
            <button 
              (click)="setActiveTab('addresses')"
              [class.bg-card]="activeTab === 'addresses'"
              [class.border-l-btn]="activeTab === 'addresses'"
              [class.border-b-btn]="activeTab === 'addresses' && !isDesktop"
              class="flex-shrink-0 md:w-full text-left px-4 py-3 flex items-center gap-3 border-l-4 md:border-l-4 border-b-2 md:border-b-0 border-l-transparent border-b-transparent hover:bg-card transition-all duration-300 text-[10px] sm:text-xs md:text-sm uppercase tracking-widest text-heading"
            >
              <span class="whitespace-nowrap">Addresses</span>
            </button>
          </nav>
        </div>
      </aside>

      <!-- Main Content -->
      <main class="flex-1 min-w-0">
        
        <!-- Profile Tab -->
        <div *ngIf="activeTab === 'profile'" class="animate-fade-in space-y-6">
          <div class="bg-white border border-[#E5DDD5] rounded-sm p-6 sm:p-10">
            <h2 class="text-2xl font-serif text-heading mb-6 pb-2 border-b border-[#E5DDD5]">Profile Details</h2>
            
            <form [formGroup]="profileForm" (ngSubmit)="updateProfile()" class="space-y-6 max-w-lg">
              <div class="space-y-2">
                <label class="block text-xs uppercase tracking-widest text-muted">Full Name</label>
                <input 
                  type="text" 
                  formControlName="displayName" 
                  class="w-full px-4 py-3 border border-[#E5DDD5] rounded-sm focus:border-btn focus:ring-1 focus:ring-btn outline-none transition-all placeholder:text-muted/40"
                  placeholder="Enter your name"
                >
              </div>
              
              <div class="space-y-2">
                <label class="block text-xs uppercase tracking-widest text-muted">Email Address</label>
                <input 
                  type="email" 
                  formControlName="email"
                  class="w-full px-4 py-3 border border-[#E5DDD5] rounded-sm bg-section text-muted cursor-not-allowed"
                >
              </div>
              
              <div class="space-y-2">
                <label class="block text-xs uppercase tracking-widest text-muted">Phone Number</label>
                <div class="flex rounded-sm overflow-hidden border border-[#E5DDD5] [&:focus-within]:border-btn transition-colors">
                  <span class="flex items-center px-3 bg-section text-body-text text-sm font-serif border-r border-[#E5DDD5] whitespace-nowrap select-none">+91</span>
                  <input 
                    type="tel" 
                    formControlName="phoneNumber" 
                    inputmode="numeric"
                    maxlength="10"
                    class="flex-1 px-4 py-3 focus:outline-none font-serif text-body-text placeholder:text-muted/40"
                    placeholder="10-digit number"
                  >
                </div>
              </div>

              <div class="pt-4">
                <button 
                  type="submit" 
                  [disabled]="profileForm.invalid || profileForm.pristine"
                  class="px-8 py-3 bg-btn text-white font-serif uppercase text-xs tracking-widest hover:bg-btn-hover transition-all duration-300 rounded-sm shadow-md disabled:opacity-50 disabled:grayscale disabled:cursor-not-allowed"
                >
                  Update My Information
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Orders Tab -->
        <div *ngIf="activeTab === 'orders'" class="animate-fade-in space-y-6">
          <div class="bg-white border border-[#E5DDD5] rounded-sm p-6 sm:p-10">
            <h2 class="text-2xl font-serif text-heading mb-8 pb-2 border-b border-[#E5DDD5]">My Orders</h2>
            
            <div *ngIf="orders.length === 0" class="text-center py-12">
              <p class="text-muted mb-4">You haven't placed any orders yet.</p>
              <a routerLink="/" class="text-heading border-b border-heading hover:text-btn hover:border-btn transition-colors uppercase text-xs tracking-widest">Start Shopping</a>
            </div>

            <div class="space-y-6">
              <div *ngFor="let order of orders" class="border border-[#E5DDD5] rounded-sm overflow-hidden hover:border-btn transition-colors bg-card/30">
                
                <!-- Order Header -->
                <div class="bg-heading/5 p-4 border-b border-[#E5DDD5] flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                  <div>
                    <p class="text-xs text-muted uppercase tracking-widest">Order Date</p>
                    <p class="text-sm font-serif text-heading">{{ order.date | date:'mediumDate' }}</p>
                  </div>
                  <div class="flex gap-4">
                    <span 
                      class="px-3 py-1 text-[10px] uppercase tracking-widest border rounded-full font-serif"
                      [ngClass]="{
                        'border-yellow-600 text-yellow-800 bg-yellow-50': order.status === 'Pending' || order.orderStatus === 'Processing',
                        'border-green-600 text-green-800 bg-green-50': order.status === 'Delivered' || order.orderStatus === 'Delivered',
                        'border-red-600 text-red-800 bg-red-50': order.status === 'Cancelled',
                        'border-blue-600 text-blue-800 bg-blue-50': order.status === 'Shipped' || order.orderStatus === 'Shipped',
                        'border-purple-600 text-purple-800 bg-purple-50': order.status === 'PAID'
                      }"
                    >
                      {{ order.orderStatus || order.status }}
                    </span>
                  </div>
                </div>

                <!-- Order Content -->
                <div class="p-4 sm:p-6">
                  
                  <!-- Products List -->
                  <div class="mb-4">
                    <h4 class="text-xs uppercase tracking-widest text-muted mb-3">Products</h4>
                    <div class="space-y-2">
                      <div *ngFor="let item of order.items" class="flex items-center gap-3 py-2">
                        <div class="w-12 h-12 bg-white border border-[#E5DDD5] rounded-sm flex-shrink-0 overflow-hidden">
                          <img [src]="item.originalProduct.image || '/assets/placeholder-botanical.jpg'" class="w-full h-full object-cover">
                        </div>
                        <div class="flex-1 min-w-0">
                          <p class="text-sm font-serif text-heading truncate">{{ item.originalProduct.name || 'Product' }}</p>
                          <div class="flex items-center gap-4">
                            <p class="text-xs text-muted">Qty: {{ item.quantity }}</p>
                            <!-- Review Section -->
                            <ng-container *ngIf="item.review; else noReview">
                              <div class="flex flex-col gap-1">
                                <div class="flex items-center gap-1 text-btn text-[10px]">
                                  <span *ngFor="let s of [1,2,3,4,5]">
                                    {{ s <= item.review.rating ? '★' : '☆' }}
                                  </span>
                                  <span class="text-muted ml-1">({{ item.review.createdAt | date:'shortDate' }})</span>
                                </div>
                                <p class="text-[10px] text-body-text/80 italic line-clamp-1">"{{ item.review.comment }}"</p>
                              </div>
                            </ng-container>

                            <ng-template #noReview>
                              <button 
                                *ngIf="order.status === 'Delivered' || order.orderStatus === 'Delivered'"
                                (click)="openReviewPopup(item.originalProduct)"
                                class="text-[10px] uppercase tracking-widest text-btn font-bold hover:text-heading transition-colors"
                              >
                                ★ Write Review
                              </button>
                            </ng-template>
                          </div>
                        </div>
                        <div class="text-sm font-bold text-heading">
                          {{ item.discountedPrice * item.quantity | currency:'INR' }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Delivery Info Grid -->
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t border-[#E5DDD5]">
                    
                    <!-- Delivery Address -->
                    <div>
                      <h4 class="text-xs uppercase tracking-widest text-muted mb-2">Delivery Address</h4>
                      <div class="text-sm text-heading leading-relaxed">
                        <p class="font-semibold">{{ order.shippingAddress.receiverName }}</p>
                        <p>{{ order.shippingAddress.street }}</p>
                        <p>{{ order.shippingAddress.city }}, {{ order.shippingAddress.state }} - {{ order.shippingAddress.zipCode }}</p>
                        <p class="text-xs text-muted mt-1">
                          {{ order.shippingAddress.countryCode }} {{ order.shippingAddress.mobileNumber }}
                        </p>
                      </div>
                    </div>

                    <!-- Delivery Date & Total -->
                    <div class="space-y-3">
                      <div *ngIf="order.deliveryDate">
                        <h4 class="text-xs uppercase tracking-widest text-muted mb-1">Expected Delivery</h4>
                        <p class="text-sm font-serif text-heading">{{ order.deliveryDate | date:'mediumDate' }}</p>
                      </div>
                      <div>
                        <h4 class="text-xs uppercase tracking-widest text-muted mb-1">Order Total</h4>
                        <p class="text-xl font-bold text-heading">{{ order.totalPrice | currency:'INR' }}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Addresses Tab -->
        <div *ngIf="activeTab === 'addresses'" class="animate-fade-in space-y-6">
          <div class="bg-white border border-[#E5DDD5] rounded-sm p-6 sm:p-10">
            <div class="flex justify-between items-center mb-8 pb-2 border-b border-[#E5DDD5]">
              <h2 class="text-2xl font-serif text-heading">My Addresses</h2>
              <button 
                *ngIf="!showAddressForm"
                (click)="initAddAddress()"
                class="px-4 py-2 border border-heading text-heading hover:bg-heading hover:text-white transition-colors uppercase text-[10px] tracking-widest rounded-sm"
              >
                + Add New
              </button>
            </div>

            <!-- Address Form -->
            <div *ngIf="showAddressForm" class="bg-card p-6 border border-[#E5DDD5] rounded-sm mb-8 animate-fade-in">
              <h3 class="text-lg font-serif text-heading mb-6">{{ isEditingAddress ? 'Edit Address' : 'Add New Address' }}</h3>
              <form [formGroup]="addressForm" (ngSubmit)="saveAddress()" class="space-y-4">
                
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div class="col-span-1 sm:col-span-2 space-y-1">
                    <label class="block text-xs uppercase tracking-widest text-muted">Address Type</label>
                    <select formControlName="type" class="w-full px-4 py-2 border border-[#E5DDD5] rounded-sm focus:border-btn focus:ring-0 outline-none bg-white">
                      <option value="Home">Home</option>
                      <option value="Work">Work</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div class="space-y-1">
                    <label class="block text-xs uppercase tracking-widest text-muted">Receiver Name</label>
                    <input type="text" formControlName="receiverName" class="w-full px-4 py-2 border border-[#E5DDD5] rounded-sm focus:border-btn focus:ring-1 focus:ring-btn outline-none" placeholder="Name of person receiving">
                  </div>

                  <div class="col-span-1 sm:col-span-2 space-y-1">
                    <label class="block text-xs uppercase tracking-widest text-muted">Mobile Number</label>
                    <div class="flex rounded-sm overflow-hidden border border-[#E5DDD5] [&:focus-within]:border-btn transition-colors">
                      <span class="flex items-center px-3 bg-section text-body-text text-sm font-serif border-r border-[#E5DDD5] whitespace-nowrap select-none">+91</span>
                      <input 
                        type="tel" 
                        formControlName="mobileNumber" 
                        class="flex-1 px-4 py-2 focus:outline-none font-serif text-body-text" 
                        inputmode="numeric"
                        maxlength="10"
                        placeholder="10-digit mobile number"
                      >
                    </div>
                  </div>
                
                  <div class="col-span-1 sm:col-span-2 space-y-1">
                    <label class="block text-xs uppercase tracking-widest text-muted">Street Address</label>
                    <input type="text" formControlName="street" class="w-full px-4 py-2 border border-[#E5DDD5] rounded-sm focus:border-btn focus:ring-1 focus:ring-btn outline-none" placeholder="Street, Sector">
                  </div>

                  <div class="space-y-1">
                    <label class="block text-xs uppercase tracking-widest text-muted">City</label>
                    <input type="text" formControlName="city" class="w-full px-4 py-2 border border-[#E5DDD5] rounded-sm focus:border-btn focus:ring-1 focus:ring-btn outline-none">
                  </div>
                  
                  <div class="space-y-1">
                    <label class="block text-xs uppercase tracking-widest text-muted">State</label>
                    <input type="text" formControlName="state" class="w-full px-4 py-2 border border-[#E5DDD5] rounded-sm focus:border-btn focus:ring-1 focus:ring-btn outline-none">
                  </div>
                  
                  <div class="space-y-1">
                    <label class="block text-xs uppercase tracking-widest text-muted">Zip Code</label>
                    <input type="text" formControlName="zipCode" inputmode="numeric" pattern="[0-9]*" class="w-full px-4 py-2 border border-[#E5DDD5] rounded-sm focus:border-btn focus:ring-1 focus:ring-btn outline-none">
                  </div>
                </div>

                <div class="flex items-center gap-2 pt-2">
                   <input type="checkbox" formControlName="isDefault" id="isDefault" class="w-4 h-4 text-heading border-[#E5DDD5] rounded focus:ring-btn">
                   <label for="isDefault" class="text-sm text-heading">Set as default address</label>
                </div>

                <!-- Validation Error Display -->
                <div *ngIf="addressForm.invalid && addressForm.touched" class="p-3 bg-red-50 border border-red-200 rounded-sm text-red-700 text-xs">
                  <strong>Please fix the following fields:</strong>
                  <ul class="list-disc list-inside mt-1">
                    <li *ngIf="addressForm.get('type')?.invalid && addressForm.get('type')?.touched">Address Type is required</li>
                    <li *ngIf="addressForm.get('receiverName')?.invalid && addressForm.get('receiverName')?.touched">Receiver Name is required</li>
                    <li *ngIf="addressForm.get('mobileNumber')?.invalid && addressForm.get('mobileNumber')?.touched">
                      Mobile Number must be exactly 10 digits
                    </li>
                    <li *ngIf="addressForm.get('street')?.invalid && addressForm.get('street')?.touched">Street Address is required</li>
                    <li *ngIf="addressForm.get('city')?.invalid && addressForm.get('city')?.touched">City is required</li>
                    <li *ngIf="addressForm.get('state')?.invalid && addressForm.get('state')?.touched">State is required</li>
                    <li *ngIf="addressForm.get('zipCode')?.invalid && addressForm.get('zipCode')?.touched">Zip Code is required</li>
                  </ul>
                </div>

                <div class="flex gap-3 pt-4">
                  <button type="submit" [disabled]="addressForm.invalid" class="px-8 py-2 bg-btn text-white uppercase text-xs tracking-widest hover:bg-btn-hover transition-all duration-300 shadow-md rounded-sm disabled:opacity-50 disabled:grayscale">Save Address</button>
                  <button type="button" (click)="cancelAddressEdit()" class="px-6 py-2 border border-heading text-heading uppercase text-xs tracking-widest hover:bg-card transition-colors rounded-sm">Cancel</button>
                </div>
              </form>
            </div>

            <!-- Address List -->
            <div *ngIf="!showAddressForm" class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div *ngIf="(!user?.addresses || user?.addresses?.length === 0) && !user?.address" class="col-span-full text-center py-8 text-muted">
                No addresses saved yet.
              </div>

              <!-- List View (Legacy/Array) -->
              <ng-container *ngIf="user?.addresses?.length">
                <div *ngFor="let address of user?.addresses; let i = index" class="group relative border border-[#E5DDD5] rounded-sm p-6 hover:border-btn transition-all bg-card/30 min-h-[160px] flex flex-col justify-between">
                  <div>
                      <div class="flex justify-between items-start mb-2">
                        <div class="flex items-center gap-2">
                          <h4 class="font-serif text-heading text-lg">{{ address.type }}</h4>
                          <span class="text-xs text-muted">({{ address.receiverName }})</span>
                        </div>
                        <span *ngIf="address.isDefault" class="bg-btn text-white text-[10px] px-2 py-0.5 uppercase tracking-widest rounded-sm">Default</span>
                      </div>
                      <p class="text-sm text-body-text leading-relaxed">
                        {{ address.street }}<br>
                        {{ address.city }}, {{ address.state }} - {{ address.zipCode }}<br>
                        <span class="text-xs mt-1 block text-heading">{{ address.mobileNumber }}</span>
                      </p>
                  </div>
                  
                  <div class="flex gap-4 mt-4 pt-4 border-t border-[#E5DDD5]/50 opacity-100 sm:opacity-0 group-hover:opacity-100 transition-opacity">
                    <button (click)="editAddress(address)" class="text-xs text-heading uppercase tracking-widest hover:text-btn transition-colors">Edit</button>
                    <button (click)="deleteAddress(i)" class="text-xs text-red-800 uppercase tracking-widest hover:text-red-600 transition-colors">Delete</button>
                  </div>
                </div>
              </ng-container>

              <!-- Single Address View (New Schema) -->
              <div *ngIf="(!user?.addresses || user?.addresses?.length === 0) && user?.address" class="group relative border border-[#E5DDD5] rounded-sm p-6 hover:border-btn transition-all bg-card/30 min-h-[160px] flex flex-col justify-between">
                  <div>
                      <div class="flex justify-between items-start mb-2">
                        <div class="flex items-center gap-2">
                          <h4 class="font-serif text-heading text-lg">{{ user!.address!.type }}</h4>
                          <span class="text-xs text-muted">({{ user!.address!.receiverName }})</span>
                        </div>
                        <span *ngIf="user!.address!.isDefault" class="bg-btn text-white text-[10px] px-2 py-0.5 uppercase tracking-widest rounded-sm">Default</span>
                      </div>
                      <p class="text-sm text-body-text leading-relaxed">
                        {{ user!.address!.street }}<br>
                        {{ user!.address!.city }}, {{ user!.address!.state }} - {{ user!.address!.zipCode }}<br>
                        <span class="text-xs mt-1 block text-heading">{{ user!.address!.mobileNumber }}</span>
                      </p>
                  </div>
                  
                  <div class="flex gap-4 mt-4 pt-4 border-t border-[#E5DDD5]/50 opacity-100 sm:opacity-0 group-hover:opacity-100 transition-opacity">
                    <button (click)="editAddress(user!.address!)" class="text-xs text-heading uppercase tracking-widest hover:text-btn transition-colors">Edit</button>
                  </div>
              </div>

            </div>
          </div>
        </div>

      </main>
    </div>
  </div>
</div>

<!-- Review Popup -->
<app-review-popup
  *ngIf="showReviewPopup && selectedProductForReview"
  [product]="selectedProductForReview"
  [userName]="user?.displayName || 'Valued Customer'"
  (close)="closeReviewPopup()"
  (submitted)="onReviewSubmitted($event)"
></app-review-popup>
